export const COMPLETED = 'COMPLETED';
export const IN_PROGRESS = 'PENDING';
export const NOT_STARTED = 'NOT STARTED';
export const PASS = 'PASS';
export const FAIL = 'FAIL';

export const statusOptions = [
  { label: 'Pending', value: IN_PROGRESS },
  { label: 'Pass', value: PASS },
  { label: 'Fail', value: FAIL },
];
